module.exports = __webpack_public_path__ + "img/e_2_13_r.dd79084e.png";